var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.644,
    height: 21.243,
    viewBox: "0 0 26.644 21.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cbced7;opacity:0.543;}.b{fill:#bcc0cb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-110.97 -216.775)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.97 216.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.482,1106.227a3.468,3.468,0,0,0,0,6.913,3.468,3.468,0,0,0,0-6.913Zm-2.92,7.9a2.65,2.65,0,0,0-2.54,2.74v4.65a.475.475,0,0,0,.454.494H13.489a.475.475,0,0,0,.453-.494v-4.65a2.65,2.65,0,0,0-2.54-2.74Z",
    transform: "translate(12.702 -1102.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.482,1106.227a3.468,3.468,0,0,0,0,6.913,3.468,3.468,0,0,0,0-6.913Zm-2.92,7.9a2.65,2.65,0,0,0-2.54,2.74v4.65a.475.475,0,0,0,.454.494H13.489a.475.475,0,0,0,.453-.494v-4.65a2.65,2.65,0,0,0-2.54-2.74Z",
    transform: "translate(-3.022 -1102.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.371,1106.227a4.668,4.668,0,0,0,0,9.3,4.668,4.668,0,0,0,0-9.3ZM6.44,1116.86a3.567,3.567,0,0,0-3.419,3.687v6.258a.64.64,0,0,0,.612.665H17.11a.64.64,0,0,0,.609-.665v-6.258a3.567,3.567,0,0,0-3.419-3.687Z",
    transform: "translate(2.968 -1106.227)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/Member.4f3d97b26505a9d717eefbabd0fa03e0.svg";
export { ForwardRef as ReactComponent };